export { Anchor } from "@mantine/core";
export type { AnchorProps } from "@mantine/core";
export { anchorOverrides } from "./Anchor.config";
